import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AgEntitiesRootComponent } from './components/ag-entities-root/ag-entities-root.component';
import { AgEntityComponent } from './components/ag-entity/ag-entity.component';
import { AgMessagesComponent } from './components/ag-messages/ag-messages.component';
import { AgTermsComponent } from './components/ag-terms/ag-terms.component';
import { AgAdviseBannerComponent } from './components/ag-advise-banner/ag-advise-banner.component';
import { AgEntitiesLoaderComponent } from './components/ag-entities-loader/ag-entities-loader.component';
import { AgEntitiesProgressComponent } from './components/ag-entities-progress/ag-entities-progress.component';
import { AgEntitiesSuccessComponent } from './components/ag-entities-success/ag-entities-success.component';

const routes: Routes = [
  // this route is needed for security POST mode, so Angular does not complain
  { path: 'entry', redirectTo: '/', pathMatch: 'full' },
  { path: '', component: AgEntitiesRootComponent},
  { path: 'advise-banner', component: AgAdviseBannerComponent},
  { path: 'loader', component: AgEntitiesLoaderComponent},
  { path: 'entities-progress', component: AgEntitiesProgressComponent},
  { path: 'entities-success', component: AgEntitiesSuccessComponent},
  { path: 'entity', component: AgEntityComponent},
  { path: 'terms', component: AgTermsComponent },
  { path: 'messages', component: AgMessagesComponent },
];

/**
 * AppRoutingModule
 * Designed to be the root routing module.
 *
 * imports:
 *  - RouterModule. Adds router directives and providers.
 *
 * exports:
 *  - RouterModule. The module with the configured routes.
 */
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule  { }
